import errorApi from '../../api/errorApi';
import { getBaseUrl } from '../../constants';
import { decrypt } from '../../secure';
import { getXApiKeyByEnv } from '../../constants';

const withoutLoginDatalake = async ({ APIPayloadToPost }) => {
  const res = await errorApi(
    `${getBaseUrl()}dashboardmenus/datalake/default_tracking`,
    APIPayloadToPost,
    'POST',
    { 'x-api-key': getXApiKeyByEnv() }
  );
  console.log('datalake response', decrypt(null, res.data.response));
};

export default withoutLoginDatalake;
